fx.ns("desktop.frame", class FrameBoard extends desktop.common.board.Board
{
    constructor(model, componentFactory, options)
    {
        super(model, componentFactory, options);
    }

    /**************************** Getters / Setters **********************/

    get frameCreation()
    {
        return this.data;
    }

    set frameCreation(val)
    {
        this.data = val;
    }

    get currentView()
    {
        if (!this._currentView)
            this._currentView = new desktop.frame.FrameView(this);
        
        return this._currentView;
    }

    /*************************** Overrides  *************************/

    buildBoard()
    {
        if (!this.frameCreation || !this.frameCreation.framePage) return;
       
        let framePage = this.frameCreation.framePage;

        this.currentArea = new shared.stage.FrameArea(framePage, this.model, this);
        this.currentArea.effect = "fade";

        this.addChild(this.currentArea, {width : this.frameCreation.pageWidth, height : this.frameCreation.pageHeight} );
        
        this.currentView.update(false);     

        if (fx.get("mode") == "creating" && this.model.photos.length > 0)
        {
            let photos = [];
            for (var i = 0; i < this.model.photos.length; i++)
                photos.push( this.model.photos.getItemAt(i) );
            let layouts = fx.service("LayoutsGenerator").getLayouts(photos);
            this.currentArea.data.addPhoto( photos, this.currentArea.creation.pageWidth, this.currentArea.creation.pageHeight, layouts[0], true );
        }
    }

    getArea()
    {
        return this.currentArea;
    }

   

    onDataEvent(event)
    {
        super.onDataEvent(event);

        if (event.type == "add-component")
        {
            if (event.detail.component_type == "photo" && event.detail.creation != "dropped")
            {
                let pageWidth = this.frameCreation.pageWidth;
                let photosComponents = currentArea.data.photosComponents;
                
                currentArea.initLayoutData();

                // TODO : limiter à 4

                if (photosComponents.length > 10)
                    return;

                let exist = false;
                for (let i = 0; i < photosComponents.length; i++)
                {
                    if ( event.detail.content == photosComponents.getItemAt(i).content)
                    {
                        exist = true;
                        break;
                    }
                }

                if (exist)
                    return;

                photosComponents.sort( (a, b) => a.x - b.x );
                // first find if a photo component is empty, and use it
                // otherwise find layout with enougth pics
                for(let i = 0; i < photosComponents.length; i++)
                {
                    let component = photosComponents.getItemAt(i);
                    if (component.content == "")
                    {
                        component.content = event.detail.content;
                        return;
                    }
                }

                let photos = [];
               
                for(let i = 0; i < photosComponents.length; i++)
                {
                    let component = photosComponents.getItemAt(i);
                    let photo = this.model.photos.find({id : component.content})
                    if (photo)
                        photos.push( photo )
                }

                let photo = this.model.photos.find({id : event.detail.content});
                if (photo)
                    photos.push( photo )

                let layouts = fx.service("LayoutsGenerator").getLayouts(photos);

                pageWidth = this.frameCreation.pageWidth;
                currentArea.data.addPhoto( photos, activePart, pageWidth, currentArea.pageHeight, currentArea.extraWidth, layouts[0], true );

                return;
            }


            if (event.detail.page)
                delete event.detail.page;

            // so ToolBar and Frame are removed
            this.currentElement = null;
            
            this.currentArea.addComponent( event.detail );
        }
            
        if (event.type == "apply-layout")
        {
            let layout = this.model.layouts.find({id : event.detail.content});

            if (this.currentArea)
                this.currentArea.applyLayout( layout /*, this.currentArea.activePart*/ );
        
            event.cancel(); // so layout is not applied somewhere else
        }
          
    }



    /*************************** Events  *************************/
  

    
    onClick(event)
    {
    }

    


    _editCurrentElement()
    {
        if (this.currentElement instanceof shared.stage.components.Text)
            this.currentElement.onEdit();
    }




});